export const SUCCESS = 'Success';
export const INVALID_EMAIL = 'The email address you entered is not valid.';
export const USER_NOT_FOUND = 'The email address you entered does not match any accounts on file.';
export const WRONG_PASSWORD = 'The password you entered is incorrect. Please try again.';
export const GENERIC_LOGIN_ERROR = 'Unable to sign in. Please check your credentials and try again. If the problem persists, please contact support.';
